module.exports = __webpack_public_path__ + "media/images/features/modification/eyecatch-mv-823b1aac97edacb2fabdacfa70f3bf97.jpg";